import React from "react"
import JobDescription from "components/JobDescription"
import ListItem from "components/ListItem"

const heroDescription = `Vi söker just nu efter en driven projektledare som vill
hjälpa oss att utvecklas och växa. Du leder ditt team och ansvarar för att projekt
når uppsatta mål. Vi ser även att du arbetar tillsammans med vår VD gällande sälj
och kundförfrågningar. Vi vill växa tillsammans med både nya och befintliga kunder
och du kommer vara en viktig del av detta.`

const experiences = [
  "Du behöver kunna uttrycka dig väl i tal och skrift, på svenska och engelska",
  "Du har sysslat med lagidrott eller någon from av lagspel, t.ex. någon e-sport",
  "Erfarenhet att arbeta i agila projekt och prioritera mellan resurser, omfattning och tid",
  "Minst ett års arbetslivserfarenhet eller tre års högskolestudier, t.ex. Systemvetenskap eller likvärdigt med relevant bakgrund för att leda digitala projekt",
]

const ProjectManager = () => {
  return (
    <JobDescription
      position="Projektledare"
      location="Uppsala"
      heroDescription={heroDescription}
      previousExperiences={experiences}
      renderJobDescription={() => (
        <React.Fragment>
          <b>Ditt arbete inkluderar</b>
          <p style={{ marginBottom: 64 }}>
            Att leda ett team med front end/back end-utvecklare och designer i
            projekt både för kund och interna projekt. Du kommer även att vara
            länken mellan kunden och ditt team. Du ansvarar för att identifiera
            utvecklingsmöjligheter och problemområden tillsammans med kund. Du
            tolkar kundens behov och får teamet att arbeta mot ett gemensamt
            mål.
          </p>
          <b>Arbetsuppgifter</b>
          <ul>
            <ListItem text="Förbereda, planera och genomföra digitala projekt, t. ex webbplatser, mobila applikationer, strategiska projekt samt integrationsprojekt" />
            <ListItem text="Planera och genomföra uppstartsmöten och workshops med kund" />
            <ListItem text="Genomföra sprintplaneringar och möten med projektteamet" />
            <ListItem text="Följa upp projektbudget samt rapportera till kunden kontinuerligt" />
            <ListItem text="Strukturera och överse TaskWorld" />
          </ul>
        </React.Fragment>
      )}
      renderWeOffer={() => (
        <React.Fragment>
          <b>Vi erbjuder</b>
          <p>
            En trevlig och lättsam arbetsplats där alla ger sitt yttersta för
            att leverera det bästa möjliga till våra kunder och samtidigt
            utveckla sig själva. Du kommer att få ett stort ansvar redan från
            start och stöttning av resterande teamet under alla dina projekt.
          </p>
        </React.Fragment>
      )}
      renderBenefits={() => (
        <React.Fragment>
          <b>Förmåner</b>
          <ul>
            <ListItem text="Gymkort" />
            <ListItem text="Tjänstepension" />
            <ListItem text="Sjukvårdsförsäkring" />
            <ListItem text="Olycksfallsförsäkring" />
            <ListItem text="Fria arbetstider" />
          </ul>
        </React.Fragment>
      )}
    />
  )
}

export default ProjectManager



// WEBPACK FOOTER //
// ./src/pages/JobDescriptions/ProjectManager/index.jsx